import en from './en.json'
import tr from './tr.json'
import ar from './ar.json'

export const Lang = {en, tr, ar}
